let productHandle = 0;
let variant_id = 0;
let variant_title = 0;
let variant_price = 0;
let username_or_post_url = ''
let qty = 0;

function scrollToTop(){
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth' // Optional: smooth scrolling animation
  });
}

function isValidURL(str) {
    try {
        new URL(str);
        return true;
    } catch (error) {
        return false;
    }
}

function openPopup() {
    // Specify URL and window features
    var windowName = "popupWindow";
    var windowFeatures = "width=600,height=400,scrollbars=yes";
    const page_type = document.querySelector('#page_type').value;
    var url = ''
    url = username_or_post_url;
    
    if(!isValidURL(url)){
      alert('Invalid URL');
      return;
    }
    // Open the new window
    window.open(url, windowName, windowFeatures);
}

function formatPrice(price) {
    // Convert price to number
    price = parseFloat(price);

    // Check if price is a valid number
    if (isNaN(price)) {
        return "Invalid Price";
    }

    // Format price to display two decimal places
    return "$" + price.toFixed(2);
}


function handleProductTabs(){


  
  var tabLinks = document.querySelectorAll('.tab-link');
  var tabContents = document.querySelectorAll('.tab-content');
  
  tabContents.forEach(function(tabContent) {
    tabContent.classList.remove('active'); // Hide all tab contents initially
  });

  tabLinks.forEach(function(tabLink) {
    tabLink.addEventListener('click', function() {
      tabLinks.forEach(tabLink => {
        tabLink.classList.remove('active')
      })
      
      tabContents.forEach(function(tabContent) {
        tabContent.classList.remove('active')
      });

      this.classList.add('active')
      var tabContentID = this.getAttribute('data-points-to-tab-content');
      var targetTabContent = document.getElementById(tabContentID);
      
      if (targetTabContent) {
        targetTabContent.classList.add("active"); // Show the clicked tab content
      }

    });
  });

  // Show the content of the first tab initially
  if (tabLinks.length > 0) {
    var firstTabId = tabLinks[0].getAttribute('data-points-to-tab-content');
    tabLinks[0].classList.add('active')
    var firstTabContent = document.getElementById(firstTabId);
    firstTabContent.classList.add('active')
  }

  document.querySelectorAll('.variant-option-radio-input').forEach(radioInput => {
    
    radioInput.addEventListener('change', () => {
      if(!radioInput.checked) return
      var price = parseFloat(radioInput.getAttribute('data-price'))
      var compare_at_price = parseFloat(radioInput.getAttribute('data-compare-at-price'))
      radioInput.closest('.tab-content').querySelector('.selected-option-price-info').innerHTML = `
        <div class="option-price-info-inner">
          <span class="option-price">${formatPrice(price)}</span>
          ${
            compare_at_price > 0 
              ? `<span class="option-compare-at-price"><del>${formatPrice(compare_at_price)}</del></span>`
              : ``
          }
        </div>
      `

    })
  })

  // select the first radio input initially
  tabContents.forEach(function(tabContent) {
    if(tabContent.querySelector('.variant-option-radio-input')){
      var firstRadioInputInThisTabContent = tabContent.querySelector('.variant-option-radio-input')
      firstRadioInputInThisTabContent.checked = true
      var changeEvent = new Event('change');
      firstRadioInputInThisTabContent.dispatchEvent(changeEvent);
    }
  });
  
}

  function goToStep(stepNumber){
    if(stepNumber > 1){
      scrollToTop()
    }
    Array.from(document.querySelectorAll('.step')).forEach(step => {
      step.classList.remove('step-active')
    })

    if(stepNumber === 2){


      var activeTab = document.querySelector('.tab-content.active');
      var checkedRadio = activeTab.querySelector('input[type="radio"]:checked');
  
      if (checkedRadio) {
        radioInput = checkedRadio
        productHandle = radioInput.getAttribute('data-product-handle');
        variant_id =  radioInput.getAttribute('data-variant-id');
        variant_title = radioInput.getAttribute('data-variant-title');
        variant_price = radioInput.getAttribute('data-price');
        variant_title = radioInput.getAttribute('data-variant-title')
        qty = parseInt(variant_title)
        var price = parseFloat(radioInput.getAttribute('data-price'))
        var compare_at_price = parseFloat(radioInput.getAttribute('data-compare-at-price'))
        var pill_text = ''
        if(radioInput.closest('.option-label-and-input-wrapper').querySelector('.pill-text')){
          pill_text = radioInput.closest('.option-label-and-input-wrapper').querySelector('.pill-text').innerText
        }
        package_name = radioInput.getAttribute('data-package-name-in-confirmation-page')

        document.querySelector('.step .selected-package').innerText = variant_title + ' '+package_name
        document.querySelector('.step .selected-price').innerHTML = `
          <div class="option-price-info-inner d-flex align-items-center" style="gap:5px">
            <span class="option-price">${formatPrice(price)}</span>
            ${
              compare_at_price > 0 
                ? `<span class="option-compare-at-price"><del>${formatPrice(compare_at_price)}</del></span><span class="pill-text px-3 mx-3 pill-text-with-height">${pill_text}</span>`
                : ``
            }
            
          </div>
        `
          
          
          variant_title + ' '+package_name
        
        if(document.querySelector('.instagram-comments-container')){
          renderInstagramComments()
        }
        
      }
      
      

    }
    
    Array.from(document.querySelectorAll('.step')).forEach(step => {
      if(parseInt(step.getAttribute('data-step')) == stepNumber){
        step.classList.add('step-active')        
      }
    })
  }

  function assignListeners(){
    Array.from(document.querySelectorAll('.go-to-next-step')).forEach(gtns => {
      gtns.addEventListener('click', () => {
        const currentStep = parseInt(gtns.closest('.step').getAttribute('data-step'))
        goToStep(currentStep+1)
      })
    })
  
    Array.from(document.querySelectorAll('.go-to-previous-step')).forEach(gtns => {
      gtns.addEventListener('click', () => {
        const currentStep = parseInt(gtns.closest('.step').getAttribute('data-step'))
        if(currentStep > 1) goToStep(currentStep-1)
      })
    })

    if(document.querySelector('.confirm')){
      document.querySelector('.confirm').addEventListener('click', () => {
        if(username_or_post_url.trim().length == 0 ){
          alert('fill all fields')
          return
        }
        if(!isValidURL(username_or_post_url)){
          alert("Enter Valid URL")
          return
        }
        
        document.querySelector('.confirm').disabled=true

        const props = {};
        props[document.querySelector('#username_or_post_url_label').value] = username_or_post_url
        if(document.querySelector('#page_type').value == 'instagram_comments'){
          props['Customized Comments'] = sampleInstagramComments.map(({c}) => c).join(' // ');
        }
        addToCart(props);
      })
    }

    if(document.querySelector('#input_for_username_or_post_url')){
      document.querySelector('#input_for_username_or_post_url').addEventListener('change', (e) => {
        username_or_post_url = e.target.value.trim()
      })
    }


  }
function handleSteps(){
  assignListeners()
}


function generateRandomString(length=10) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

let sampleInstagramComments = [{id: generateRandomString(), c: ''}];

function deleteComment(idd){
  sampleInstagramComments = sampleInstagramComments.filter( ({id}) => id !== idd )
  renderInstagramComments(autofocusLast=true)
}

function removeAutofocus(){
  document.querySelectorAll("input[autofocus]").forEach(function(input) {
      input.removeAttribute("autofocus");
  });
}

function handleCommentInputChange(e){
  const target = e.target;
  const targetID = target.getAttribute('id');
  const existingIndex = sampleInstagramComments.findIndex(comment => comment.id === targetID);
  console.log("terobau")
  if (existingIndex !== -1) {
    console.log("id exists")
    sampleInstagramComments[existingIndex].c = target.value.trim();
  } else {
    console.log("id does not exist")
    sampleInstagramComments.push({ c: target.value, id: targetID });
  }
  updateCommentsCounts()

}

function addInputBox(){

      var activeTab = document.querySelector('.tab-content.active');
      var checkedRadio = activeTab.querySelector('input[type="radio"]:checked');
  
      if (checkedRadio) {
        radioInput = checkedRadio
        productHandle = radioInput.getAttribute('data-product-handle');
        variant_id =  radioInput.getAttribute('data-variant-id');
        variant_title = radioInput.getAttribute('data-variant-title');
        variant_price = radioInput.getAttribute('data-price');
        variant_title = radioInput.getAttribute('data-variant-title')
        qty = parseInt(variant_title)
        if(sampleInstagramComments.length < qty){
          sampleInstagramComments.push({id: generateRandomString(), c: '' })
          renderInstagramComments(autofocusLast = true)
          updateCommentsCounts()
        }
      }
}

function updateCommentsCounts(){

      var activeTab = document.querySelector('.tab-content.active');
      var checkedRadio = activeTab.querySelector('input[type="radio"]:checked');
  
      if (checkedRadio) {
        radioInput = checkedRadio
        productHandle = radioInput.getAttribute('data-product-handle');
        variant_id =  radioInput.getAttribute('data-variant-id');
        variant_title = radioInput.getAttribute('data-variant-title');
        variant_price = radioInput.getAttribute('data-price');
        variant_title = radioInput.getAttribute('data-variant-title')
        qty = parseInt(variant_title)
        const limit = qty
        Array.from(document.querySelectorAll('.comments-count')).forEach(cc => {
          console.log(sampleInstagramComments)
          cc.innerText = `${[...new Set(sampleInstagramComments.map(({c}) => c.trim() ))].filter(v=> v.length > 0).length} / ${limit} comments`
        })
      }
}

function handleEnterKey(event){
  if (event.key === "Enter") {
    addInputBox()
  }
}

function renderInstagramComments(autofocusLast = false){
      var activeTab = document.querySelector('.tab-content.active');
      var checkedRadio = activeTab.querySelector('input[type="radio"]:checked');
  
      if (checkedRadio) {
        radioInput = checkedRadio
        productHandle = radioInput.getAttribute('data-product-handle');
        variant_id =  radioInput.getAttribute('data-variant-id');
        variant_title = radioInput.getAttribute('data-variant-title');
        variant_price = radioInput.getAttribute('data-price');
        variant_title = radioInput.getAttribute('data-variant-title')
        qty = parseInt(variant_title)
        
        document.querySelector('.instagram-comments-container').innerHTML = `
          <div>
            <div class="comments-count text-muted text-small"></div>
            <div>
              ${
                sampleInstagramComments.map(({c, id}, index) => {
                  return`
                    <div class="d-flex align-items-center justify-content-between mt-2">
                        <input 
                          onkeyup="handleEnterKey(event)" 
                          type="text" 
                          value="${c}"
                          placeholder="Write a Comment"
                          oninput="handleCommentInputChange(event)" 
                          id="${id}" 
                          ${autofocusLast && index === sampleInstagramComments.length -1 ? "class='focus-it'" : ''}
                        />
                      ${sampleInstagramComments.length < qty && index === sampleInstagramComments.length-1 && `
                          <div class="add-icon icon-wrapper text-center">
                            <i onclick="addInputBox()" class="fa fa-plus action-icon"></i>
                          </div>
                        `|| ''                     
                      }
                      ${
                        sampleInstagramComments.length > 1 && index > 0 && `
                          <div class="delete-icon icon-wrapper text-center" >
                            <i onclick="deleteComment('${id}')" class="fa fa-trash action-icon"></i>
                          </div>
                        ` || ''
                      }
                    </div>
                  `
                }).join('')
              }
            </div>
            ${
                sampleInstagramComments.length > 4 && `
                  <div class="comments-count text-muted text-small"></div>
                ` || ''
            }
          </div>
        `
        if(document.querySelector('.focus-it')){
          removeAutofocus()
          document.querySelector('.focus-it').focus()
        }
        updateCommentsCounts()
      }
}

document.addEventListener('DOMContentLoaded', function() {
  handleSteps()
  handleProductTabs()

  if(document.querySelector('.instagram-comments-container')){
    renderInstagramComments()
  }
  
});

// $(document).ready(function () {
//     var silder = $(".owl-carousel");
//     silder.owlCarousel({
//         autoPlay: true,
//         items: 1,
//         center: false,
//         nav: false,
//         margin: 0,
//         dots: true,
//         loop: true,
//         responsive: {
//             0: {
//                 items: 1,
//             },
//             575: { items: 1 },
//             768: { items: 2 },
//             1200: { items: 3 }
//         }
//     });
// });

function addToCart(properties) {

      var activeTab = document.querySelector('.tab-content.active');
      var checkedRadio = activeTab.querySelector('input[type="radio"]:checked');
  
      if (checkedRadio) {
        radioInput = checkedRadio
        productHandle = radioInput.getAttribute('data-product-handle');
        variant_id =  radioInput.getAttribute('data-variant-id');
        variant_title = radioInput.getAttribute('data-variant-title');
        variant_price = radioInput.getAttribute('data-price');
        variant_title = radioInput.getAttribute('data-variant-title')
        qty = parseInt(variant_title)
  
        document.querySelector('.confirm').innerHTML = '<i class="fa fa-spinner fa-spin"></i>'
        var data = {
          items: [
            {
              id: variant_id,
              quantity: 1
            }
          ]
        };
      
        if (properties) {
          data.items[0].properties = properties;
        }
      
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: data,
          success: function(response) {
            // Cart updated successfully
            console.log(response);
            document.querySelector('.confirm').disabled=false
            document.querySelector('.confirm').innerHTML = 'Continue'
            window.location.href='/checkout'
          },
          error: function(xhr, status, error) {
            // Handle errors
            alert('Error adding to cart - ', xhr.responseText)
            document.querySelector('.confirm').disabled=false
            document.querySelector('.confirm').innerHTML = 'Continue'
            console.log(xhr.responseText);
          }
        });
      }else{
        document.querySelector('.confirm').disabled=false
        document.querySelector('.confirm').innerHTML = 'Continue'
        alert("no active tab")
      }
}


function adjustMegaMenuPosition() {
  $('.mega-menu .dropdown-menu').each(function() {
    var $this = $(this);
    var $dropdownToggle = $this.parent().find('.dropdown-toggle');
    var dropdownOffset = $dropdownToggle.offset().left;
    var dropdownWidth = $this.outerWidth();
    var windowWidth = $(window).width();
    var right = windowWidth - $dropdownToggle.offset().left - $dropdownToggle.outerWidth() - 50

    // If enough space on both left and right, position menu at the center of the parent
    if (dropdownOffset > dropdownWidth && (windowWidth - dropdownOffset - $dropdownToggle.outerWidth()) > dropdownWidth) {
      $this.css({
        'left': '50%',
        'right': 'unset',
        'transform': 'translateX(-50%)'
      });
    } else {
      // If not enough space on the right, position it to the left
      if (windowWidth - dropdownOffset < dropdownWidth) {
        $this.css({
          'left': 'auto',
          'transform': 'none',
          'right': `-${right}px`
        });
      } else {
        // Otherwise, position it to the right
        $this.css({
          'left': 'auto',
          'right': 'auto'
        });
      }
    }
  });
}

$(document).ready(function() {
  // Initialize adjustMegaMenuPosition on load and resize
  adjustMegaMenuPosition();
  $(window).on('resize', function() {
    adjustMegaMenuPosition();
  });
});



  $(document).ready(function() {
      function adjustClasses() {
          $('.tab-content').each(function() {
              var abcDivs = $(this).find('.option-label-and-input-wrapper');
              var totalDivs = abcDivs.length;
              

              // For medium and larger devices
              if ($(window).width() >= 768) {
                var remainder = totalDivs % 3;
                  if (remainder === 1) {
                      abcDivs.last().removeClass('col-md-4').addClass('col-md-12');
                      abcDivs.last().css('text-align', 'center'); // Center the last div
                  } else if (remainder === 2) {
                      abcDivs.slice(-2).removeClass('col-md-4').addClass('col-md-6');
                  }
              }

              // For smaller devices
              if ($(window).width() < 768) {
                var remainder = totalDivs % 2;
                  if (remainder === 1) {
                      abcDivs.last().removeClass('col-6').addClass('col-12');
                  }
              }
          });
      }

      adjustClasses(); // Initial adjustment

      $(window).resize(function() {
          adjustClasses(); // Adjust classes on window resize
      });
  });

    $(document).ready(function(){
        // Initialize popover
        $('[data-toggle="popover"]').popover();
        // Hide popovers when clicking outside of them
      
    });


// JavaScript for toggling dropdown menu on click for mobile devices
// document.addEventListener("DOMContentLoaded", function() {

//   if(window.innerWidth < 600){
//     var dropdownToggle = document.querySelector('.nav-link.dropdown-toggle');
//     var dropdownMenu = document.querySelector('.dropdown-menu');
  
//     // Toggle dropdown menu on click for mobile devices
//     dropdownToggle && dropdownToggle.addEventListener('click', function() {
//       if (dropdownMenu.style.display === 'flex') {
//         dropdownMenu.style.display = 'none';
//       } else {
//         dropdownMenu.style.display = 'flex';
//       }
//     });
//   }
// });



$(document).ready(function () {
    var silder = $(".owl-carousel");
    silder.owlCarousel({
        autoPlay: true,
        items: 1,
        center: false,
        nav: false,
        margin: 0,
        dots: true,
        loop: true,
        responsive: {
            0: {
                items: 1,
            },
            575: { items: 1 },
            768: { items: 2 },
            1200: { items: 3 }
        }
    });
});


  $(document).ready(function() {
    $('.read-more-container').each(function() {
      var $container = $(this);
      var $content = $container.find('.read-more-content');
      var $toggle = $container.find('.read-more-toggle');
      console.log($content.prop('scrollHeight'))
      if ($content.prop('scrollHeight') > 100) {
        $toggle.addClass('show-toggle');  // Show toggle only if content exceeds 100px height
      }

      $toggle.click(function() {
        if ($content.hasClass('expanded')) {
          $content.removeClass('expanded').css('max-height', '100px');
          $toggle.text('Read more');
        } else {
          $content.addClass('expanded').css('max-height', $content.prop('scrollHeight') + 'px');
          $toggle.text('Read less');
        }
      });
    });
  });




  $(document).ready(function () {
  $('.our-best-services .grid--gapless').each(function (index) {
    if (index % 2 === 1) { // Apply to every alternate div (starting from the second one)
      $(this).addClass('image-with-text__grid--reverse');
    }
  });
});

